module.exports = __webpack_public_path__ + "static/img/preview.9092e371.png";